// eslint-disable import/no-mutable-exports
let baseUrl, phrUrl, socketUrl, phrUrlV2, baseUrlV2, pwsUrl, phrServiceUrl, opentokApiKey;
if (import.meta.env.VITE_API_ENV === 'qa') {
  phrUrl = import.meta.env.VITE_PHR_BASE_URL_QA;
  phrUrlV2 = import.meta.env.VITE_PHR_BASE_URL_QA_v2;
  baseUrl = import.meta.env.VITE_CHR_BASE_URL_QA;
  baseUrlV2 = import.meta.env.VITE_CHR_BASE_URL_QA_v2;
  socketUrl = import.meta.env.VITE_SOCKET_URL_QA;
  pwsUrl = import.meta.env.VITE_PWS_BASE_URL_QA;
  phrServiceUrl = import.meta.env.VITE_PHR_SERVICE_URL_QA;
  opentokApiKey = import.meta.env.VITE_OPENTOK_QA_APIKEY;
} else if (import.meta.env.VITE_API_ENV === 'release') {
  phrUrl = import.meta.env.VITE_PHR_BASE_URL_RELEASE;
  phrUrlV2 = import.meta.env.VITE_PHR_BASE_URL_RELEASE_v2;
  baseUrl = import.meta.env.VITE_CHR_BASE_URL_RELEASE;
  baseUrlV2 = import.meta.env.VITE_CHR_BASE_URL_RELEASE_v2;
  socketUrl = import.meta.env.VITE_SOCKET_URL_RELEASE;
  pwsUrl = import.meta.env.VITE_PWS_BASE_URL_RELEASE;
  phrServiceUrl = import.meta.env.VITE_PHR_SERVICE_URL_RELEASE;
  opentokApiKey = import.meta.env.VITE_OPENTOK_RELEASE_APIKEY;
} else if (import.meta.env.VITE_API_ENV === 'prod') {
  phrUrl = import.meta.env.VITE_PHR_BASE_URL_PROD;
  phrUrlV2 = import.meta.env.VITE_PHR_BASE_URL_PROD_v2;
  baseUrl = import.meta.env.VITE_CHR_BASE_URL_PROD;
  baseUrlV2 = import.meta.env.VITE_CHR_BASE_URL_PROD_v2;
  socketUrl = import.meta.env.VITE_SOCKET_URL_PROD;
  pwsUrl = import.meta.env.VITE_PWS_BASE_URL_PROD;
  phrServiceUrl = import.meta.env.VITE_PHR_SERVICE_URL_PROD;
  opentokApiKey = import.meta.env.VITE_OPENTOK_PROD_APIKEY;
} else if (import.meta.env.VITE_API_ENV === 'local') {
  phrUrl = import.meta.env.VITE_PHR_BASE_URL_LOCAL;
  baseUrl = import.meta.env.VITE_CHR_BASE_URL_LOCAL;
  baseUrlV2 = import.meta.env.VITE_CHR_BASE_URL_LOCAL_v2;
  socketUrl = import.meta.env.VITE_SOCKET_URL_LOCAL;
  pwsUrl = import.meta.env.VITE_PWS_BASE_URL_LOCAL;
  phrServiceUrl = import.meta.env.VITE_PHR_SERVICE_URL_LOCAL;
  phrUrlV2 = import.meta.env.VITE_PHR_BASE_URL_LOCAL_v2;
}

export { baseUrl, phrUrl, socketUrl, phrUrlV2, baseUrlV2, pwsUrl, phrServiceUrl, opentokApiKey };
